import React, { useContext, useState } from "react";
import { ButtonType } from "components/atoms/Button/types";
import { createComment } from "lib/actions";
import { AppContext } from "lib/contexts";
import { AppReducerActionType, ICommentDTO, ICreateCommentRequest } from "types";
import * as Styled from "./ReplySection.styled";
interface ReplySectionProps {
  parentId?: string;
  imageId: string;
  onNewComment: (newComment: ICommentDTO) => void;
}
const ReplySection: React.FC<ReplySectionProps> = ({
  parentId,
  imageId,
  onNewComment
}) => {
  const {
    state,
    dispatch
  } = useContext(AppContext);
  const [content, setContent] = useState("");
  const [attachmentUrl, setAttachmentUrl] = useState("");
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!state.isLoggedIn) {
      dispatch({
        type: AppReducerActionType.SHOW_AUTH_MODAL,
        payload: {
          ...state,
          showAuthModal: true
        }
      });
      return;
    }
    const commentRequest: ICreateCommentRequest = {
      content,
      attachmentUrl,
      parentCommentId: parentId ?? undefined,
      imageId
    };
    const response = await createComment(commentRequest);
    if (response.error) {
      console.error("Failed to create comment:", response.error);
    } else if (response.comment) {
      setContent("");
      setAttachmentUrl("");
      onNewComment(response.comment);
    }
  };
  return <Styled.ReplyForm onSubmit={handleSubmit} data-sentry-element="unknown" data-sentry-component="ReplySection" data-sentry-source-file="index.tsx">
            <Styled.TextArea value={content} onChange={e => {
      e.stopPropagation();
      setContent(e.target.value);
    }} onKeyDown={e => {
      if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
        e.stopPropagation();
      }
    }} placeholder="Write a comment..." required data-sentry-element="unknown" data-sentry-source-file="index.tsx" />
            <Styled.Button variant={ButtonType.SUCCESS} type="submit" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                Comment
            </Styled.Button>
        </Styled.ReplyForm>;
};
export default ReplySection;